import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import WSButton from '../../../../_metronic/helpers/components/WSButton/WSButton'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import {AuthenticateUser} from '../../../Utils/_helpers/RoleAndPermission'
import {DeleteData, GetAllData, SetDefaultData} from './OptoutSlice/OptoutListSlice'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../Components/NodataYet'
import {getUserData} from '../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const OptOutLists = () => {
  const navigate = useNavigate()

  const dispatch = useDispatch()
  // const OptOutDefault = useSelector(getUserData)?.ownerData
  const optoutList = useSelector((state: any) => state?.optoutList?.optoutList?.data)
  const OptOutDefault = useSelector((state: any) => state?.userDetails?.userDetails?.data?.user)

  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [page, setPage] = useState({page: 1, size: 10})

  useEffect(() => {
    dispatch(GetAllData())
  }, [])
  useEffect(() => {
    if (page.page || page.size) {
      dispatch(GetAllData(page))
    }
  }, [page.page, page.size])

  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteData({
          optIds: [...deleteIds],
        })
      )
      setConfirm(false)
    }
  }, [confirm])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete optout?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )
  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }

  return (
    <>
      {confirmation}
      <div className={`card virtual-table`}>
        <div className='card-header border-0 pt-9 ps-10'>
          <h3 className='card-title align-items-start  flex-column'>
            <div>
              <span className='fw-bolder fs-2 mb-1'>Custom Opt Out</span>
              <OverlayTrigger
                  placement='bottom'
                  overlay={<Tooltip id="tooltip-bottom">
                    <div>
                      <span>Create a custom opt-out form to understand why customers unsubscribe. Gain valuable insights to improve your messaging, offers, and overall customer experience.</span>
                    </div>
                  </Tooltip>}
                >
                  <i
                    className='m-2 svg-icon-3 svg-icon-gray-500 cursor-pointer bi-info-circle'
                  />
              </OverlayTrigger>
            </div>
            <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
          </h3>
          {AuthenticateUser('create-custom-opt-out') && (
            <div className='card-toolbar align-items-start flex-column'>
              <a className='btn btn-sm btn-primary fw-500' onClick={() => navigate('/opt-out')}>
                Create new
              </a>
            </div>
          )}
        </div>
        {optoutList?.items?.length > 0 ? (
          <div className='card-body'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-100 align-middle gs-0 gy-6 customOptOut_table'>
                <thead>
                  <tr className='fw-400 text-dark text-muted '>
                    <th className=' rounded-start'>NAME</th>
                    <th className=''>Description</th>
                    <th className=''>CREATED</th>
                    <th className=''>OPTION 1</th>
                    <th className=''>OPTION 2</th>
                    <th className=''>OPTION 3</th>
                    <th className=''>OPTION 4</th>
                    <th className=' text-end'>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {optoutList?.items?.map((data: any, idx: number) => {
                    return (
                      <tr key={idx} className=''>
                        <td className=''>{data?.title}</td>
                        <td className='desc'>{data?.description}</td>
                        <td>{moment(data?.createdAt).format('DD/MM/YYYY')}</td>
                        {data?.options?.map((key: any, index: any) => {
                          let keyLabel = `option${index + 1}`
                          let finalValue = key?.[`${keyLabel}`]

                          return <td key={finalValue}>{finalValue}</td>
                        })}
                        {4 - +data?.options?.length >= 0 && (
                          <>
                            {new Array(4 - data?.options?.length)
                              ?.fill('')
                              ?.map((key: any, i: number) => (
                                <td key={i}>-</td>
                              ))}
                          </>
                        )}

                        <td className='text-end'>
                          {AuthenticateUser('edit-custom-opt-out') && (
                            <>
                              {data?._id === OptOutDefault?.defaultOptoutId ? (
                                <WSButton
                                  onClick={() => {
                                    dispatch(
                                      SetDefaultData({
                                        optId: data?._id,
                                        isDefault: false,
                                        // ownerId: OptOutDefault?._id,
                                      })
                                    )
                                  }}
                                  className={'btn btn-sm default me-3 fw-500'}
                                >
                                  Default
                                </WSButton>
                              ) : (
                                <WSButton
                                  className={
                                    'btn btn-sm btn-light btn-active-light-primary me-3 fw-500'
                                  }
                                  onClick={() => {
                                    dispatch(
                                      SetDefaultData({
                                        optId: data?._id,
                                        isDefault: true,
                                        // ownerId: OptOutDefault?._id,
                                      })
                                    )
                                  }}
                                >
                                  Set as default
                                </WSButton>
                              )}
                            </>
                          )}
                          {!data?.isAdmin && AuthenticateUser('edit-custom-opt-out') && (
                            <button
                              className='btn btn-sm btn-icon btn-light btn-active-light-primary me-2'
                              onClick={() =>
                                navigate('/opt-out', {
                                  state: {
                                    id: idx,
                                    data: data,
                                  },
                                })
                              }
                            >
                              <KTSVG
                                path='/media/icons/duotune/art/art005.svg'
                                className='svg-icon-2'
                              />
                            </button>
                          )}
                          {!data?.isAdmin && AuthenticateUser('delete-custom-opt-out') && (
                            <button
                              className='btn btn-sm btn-icon btn-light btn-active-light-primary delete_action'
                              onClick={() => handleDelete(data?._id)}
                            >
                              <KTSVG
                                className='svg-icon-2'
                                path='/media/icons/duotune/art/trush.svg'
                              />
                            </button>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div className='abcd '>
              <select
                className='SelectSize'
                onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={optoutList?.total}>ALl</option>
              </select>
              <ReactPaginate
                previousLabel='<'
                nextLabel='>'
                pageCount={optoutList?.totalPages}
                onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                containerClassName={'pagiantion'}
                previousLinkClassName={'pagination__link'}
                nextLinkClassName={'pagination__link'}
                disabledClassName={'pagination__link--disabled'}
                activeClassName={'pagination__link--active'}
              />
            </div>
          </div>
        ) : (
          <NodataYet />
        )}
      </div>
    </>
  )
}

export default OptOutLists
